/* =============================================================
   RANZEN KIDS — Collection Page JS
   Sidebar accordion + Price slider + View toggle + Sort + Mobile
   ============================================================= */

(function () {
  'use strict';

  /* ---- 1. Category Tree Accordion ---- */
  document.querySelectorAll('.cat-tree__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const item     = btn.closest('.cat-tree__item');
      const children = item.querySelector('.cat-tree__children');
      const expanded = btn.getAttribute('aria-expanded') === 'true';

      btn.setAttribute('aria-expanded', String(!expanded));
      btn.classList.toggle('cat-tree__toggle--active', !expanded);
      if (children) {
        children.classList.toggle('cat-tree__children--visible', !expanded);
      }
      item.classList.toggle('cat-tree__item--open', !expanded);
    });
  });

  /* ---- 2. Price Slider ---- */
  const sliderEl = document.getElementById('rz-price-slider');
  if (sliderEl) {
    const rangeEl      = document.getElementById('rz-price-range');
    const minHandle    = sliderEl.querySelector('.price-slider__handle--min');
    const maxHandle    = sliderEl.querySelector('.price-slider__handle--max');
    const minDisplay   = document.getElementById('rz-price-min-display');
    const maxDisplay   = document.getElementById('rz-price-max-display');
    const minInput     = document.getElementById('rz_price_min');
    const maxInput     = document.getElementById('rz_price_max');

    const GLOBAL_MIN   = parseInt(sliderEl.dataset.min || '0', 10);
    const GLOBAL_MAX   = parseInt(sliderEl.dataset.max || '5000', 10);

    // Leer valores actuales de la URL (por si hay filtro activo)
    const params   = new URLSearchParams(window.location.search);
    let minVal     = parseInt(params.get('filter.v.price.gte') || sliderEl.dataset.min || '0', 10);
    let maxVal     = parseInt(params.get('filter.v.price.lte') || sliderEl.dataset.max || '5000', 10);

    function fmt(n) { return n.toLocaleString('es-UY'); }

    function updateUI() {
      const minPct = ((minVal - GLOBAL_MIN) / (GLOBAL_MAX - GLOBAL_MIN)) * 100;
      const maxPct = ((maxVal - GLOBAL_MIN) / (GLOBAL_MAX - GLOBAL_MIN)) * 100;
      minHandle.style.left  = minPct + '%';
      maxHandle.style.left  = maxPct + '%';
      rangeEl.style.left    = minPct + '%';
      rangeEl.style.right   = (100 - maxPct) + '%';
      if (minDisplay) minDisplay.textContent = fmt(minVal);
      if (maxDisplay) maxDisplay.textContent = fmt(maxVal);
      if (minInput)   minInput.value = minVal;
      if (maxInput)   maxInput.value = maxVal;
    }

    function makeDraggable(handle, isMin) {
      function onDrag(clientX) {
        const rect = sliderEl.getBoundingClientRect();
        const pct  = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        const val  = Math.round(GLOBAL_MIN + pct * (GLOBAL_MAX - GLOBAL_MIN));
        if (isMin) { minVal = Math.min(val, maxVal - 100); }
        else        { maxVal = Math.max(val, minVal + 100); }
        updateUI();
      }

      // Mouse
      handle.addEventListener('mousedown', e => {
        e.preventDefault();
        const onMove = ev => onDrag(ev.clientX);
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', () =>
          document.removeEventListener('mousemove', onMove), { once: true });
      });

      // Touch
      handle.addEventListener('touchstart', e => {
        e.preventDefault();
        let _touchTicking = false;
        const onMove = ev => {
          if (_touchTicking) return;
          _touchTicking = true;
          requestAnimationFrame(() => {
            onDrag(ev.touches[0].clientX);
            _touchTicking = false;
          });
        };
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', () =>
          document.removeEventListener('touchmove', onMove), { once: true });
      }, { passive: false });
    }

    makeDraggable(minHandle, true);
    makeDraggable(maxHandle, false);
    updateUI();

    // Submit: construye la URL con los params de precio + sort actual
    const priceForm = document.getElementById('rz-price-form');
    if (priceForm) {
      priceForm.addEventListener('submit', e => {
        e.preventDefault();
        const url    = new URL(window.location.href);
        url.searchParams.set('filter.v.price.gte', minVal);
        url.searchParams.set('filter.v.price.lte', maxVal);
        url.searchParams.delete('page'); // reset pagination al filtrar
        window.location.href = url.toString();
      });
    }
  }

  /* ---- 3. View Toggle (grid 4 / grid 3 / list) ---- */
  const STORAGE_KEY = 'rz_collection_view';
  const grid = document.querySelector('.rz-product-grid');

  function setView(view) {
    if (!grid) return;
    grid.classList.remove('rz-product-grid--cols-3', 'rz-product-grid--cols-list');
    if (view === 'grid3') grid.classList.add('rz-product-grid--cols-3');
    if (view === 'list')  grid.classList.add('rz-product-grid--cols-list');

    document.querySelectorAll('.view-toggle__btn').forEach(btn => {
      btn.classList.toggle('view-toggle__btn--active', btn.dataset.view === view);
    });
    try { localStorage.setItem(STORAGE_KEY, view); } catch (_) {}
  }

  // Restaurar preferencia guardada
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) setView(saved);
    else        setView('grid4');
  } catch (_) { setView('grid4'); }

  document.querySelectorAll('.view-toggle__btn').forEach(btn => {
    btn.addEventListener('click', () => setView(btn.dataset.view));
  });

  /* ---- 4. Sort — auto-submit al cambiar ---- */
  const sortSelect = document.querySelector('.sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => sortSelect.closest('form').submit());
  }

  /* ---- 5. Mobile Sidebar open/close ---- */
  const sidebarToggle  = document.querySelector('.rz-sidebar-toggle');
  const sidebar        = document.querySelector('.collection-sidebar');
  const overlay        = document.querySelector('.rz-sidebar-overlay');

  function openSidebar() {
    sidebar && sidebar.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    sidebar && sidebar.classList.remove('is-open');
    overlay && overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (sidebarToggle) sidebarToggle.addEventListener('click', openSidebar);
  if (overlay)       overlay.addEventListener('click', closeSidebar);

  // Botón cerrar dentro del sidebar
  const closeBtns = document.querySelectorAll('.rz-sidebar-close');
  closeBtns.forEach(btn => btn.addEventListener('click', closeSidebar));

/* ---- 6. Product Card Carousel ---- */
  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const track = carousel.querySelector('.product-card__carousel-track');
    const slides = carousel.querySelectorAll('.product-card__carousel-slide');
    const dots = carousel.querySelectorAll('.product-card__dot');
    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = null;

    if (slides.length <= 1) return;

    function updateCarousel() {
      currentTranslate = currentIndex * -100;
      track.style.transform = `translateX(${currentTranslate}%)`;
      dots.forEach((dot, i) => {
        dot.classList.toggle('product-card__dot--active', i === currentIndex);
      });
    }

    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      updateCarousel();
    }

    // Click dots
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goToSlide(i));
    });

    // Touch/Mouse drag
    track.addEventListener('mousedown', startDrag);
    track.addEventListener('touchstart', startDrag);

    function startDrag(e) {
      isDragging = true;
      startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      prevTranslate = currentTranslate;
      animationID = requestAnimationFrame(animation);
    }

    document.addEventListener('mousemove', drag);
    document.addEventListener('touchmove', drag, { passive: false });

    function drag(e) {
      if (!isDragging) return;
      const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      currentTranslate = prevTranslate + ((currentX - startX) / track.offsetWidth) * 100;
    }

    document.addEventListener('mouseup', stopDrag);
    document.addEventListener('touchend', stopDrag);

    function stopDrag() {
      isDragging = false;
      cancelAnimationFrame(animationID);
      const movedBy = currentTranslate - prevTranslate;
      if (Math.abs(movedBy) > 20) {
        goToSlide(movedBy > 0 ? currentIndex - 1 : currentIndex + 1);
      } else {
        updateCarousel();
      }
    }

    function animation() {
      if (isDragging) {
        track.style.transform = `translateX(${currentTranslate}%)`;
      }
    }
  });

})();
